import moment from 'moment';

export const LOCATION_ENTITY_NAME = 'Location';
export const JOBTYPE_REPORT = 'report';

export const selectors = {
  date: 'date',
  dayOfWeek: 'dayOfWeek',
  dayOfMonth: 'dayOfMonth',
  dayAndMonth: 'dayAndMonth',
};

export const frequencyIds = {
  daily: 0,
  monthly: 1,
  yearly: 2,
  once: 3,
};

export const frequencies = [
  {
    id: frequencyIds.daily,
    name: 'Täglich',
    selector: selectors.dayOfWeek,
    defaultInterval: 0,
  },
  {
    id: frequencyIds.monthly,
    name: 'Monatlich',
    selector: selectors.dayOfMonth,
    defaultInterval: 1,
  },
  {
    id: frequencyIds.yearly,
    name: 'Jährlich',
    selector: selectors.dayAndMonth,
    defaultInterval: 1,
  },
  {
    id: frequencyIds.once,
    name: 'Einmalig',
    selector: selectors.date,
    defaultInterval: 0,
  },
];

export const periods = [
  {
    id: 0,
    name: 'Letzter Tag',
    duration: moment.duration(1, 'day').asMilliseconds(),
    offsetUnitName: 'Tage',
  },
  {
    id: 1,
    name: 'Letzte Woche',
    duration: moment.duration(1, 'week').asMilliseconds(),
    offsetUnitName: 'Wochen',
  },
  {
    id: 2,
    name: 'Letzter Monat',
    duration: moment.duration(1, 'month').asMilliseconds(),
    offsetUnitName: 'Monate',
    additionalOptions: {
      DynamicDuration: true,
    },
  },
  {
    id: 3,
    name: 'Letztes Jahr',
    duration: moment.duration(1, 'year').asMilliseconds(),
    offsetUnitName: 'Jahre',
    additionalOptions: {
      DynamicDuration: true,
    },
  },
];
